// extracted by mini-css-extract-plugin
export default {"brandPromo":"mH-z","carousel":"nH-z"};